import React from 'react';
import style from './index.module.css';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import MyFooter from '../../components/MyFooter';
import ContactForm from '../../components/ContactForm';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const Contact = () => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	const contactCards = [
		{
			icon: <PhoneIcon fontSize='large' />,
			title: 'Phone',
			content: ['+91 9827078928', '+91 9300661900'],
		},
		{
			icon: <EmailIcon fontSize='large' />,
			title: 'Email',
			content: ['deependrasinghthakur@gmail.com', 'dharmendrasinghthakur@gmail.com'],
		},
		{
			icon: <HomeIcon fontSize='large' />,
			title: 'Our Location',
			content: ['13, Mugli road, Near Bhopal Naka,', 'Ashta - 466116, Sehore (M.P.)'],
		},
	];

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			style={{
				width: '100%',
				minHeight: '100vh',
				backgroundColor: theme.palette.background.default,
				color: theme.palette.text.primary,
			}}
		>
			<div className={style.container}>
				<div className={style.header}>
					<p style={{ color: theme.palette.primary.main }}>GET IN TOUCH</p>
					<h1>Contact Us</h1>
				</div>

				<div className={style.contactCardSection}>
					{contactCards.map((card, index) => (
						<motion.div 
							key={index}
							whileHover={{ y: -10 }}
							className={style.card}
							style={{
								backgroundColor: isDark ? 'rgba(255, 255, 255, 0.05)' : theme.palette.background.paper,
								boxShadow: isDark ? '0 10px 30px rgba(0,0,0,0.4)' : '0 10px 30px rgba(0,0,0,0.05)',
							}}
						>
							<div className={style.iconStyle} style={{ backgroundColor: theme.palette.primary.main }}>
								{card.icon}
							</div>
							<h2 className={style.cardHeadingText} style={{ color: theme.palette.text.primary }}>{card.title}</h2>
							{card.content.map((text, i) => (
								<p key={i} className={style.cardContentText} style={{ color: theme.palette.text.secondary }}>{text}</p>
							))}
						</motion.div>
					))}
				</div>

				<div className={style.formSection}>
					<div className={style.sectionHeader}>
						<p style={{ color: theme.palette.primary.main }}>ENQUIRY</p>
						<h1>Send us a Message</h1>
					</div>
					<ContactForm />
				</div>

				<div className={style.socialSection} style={{ backgroundColor: isDark ? 'rgba(124, 77, 255, 0.05)' : '#f9f9f9' }}>
					<p className={style.socialSubHeader} style={{ color: theme.palette.primary.main }}>SOCIALIZE</p>
					<h2 className={style.socialHeader}>Let's Talk about Your Event</h2>
					
					<div className={style.socialLinks}>
						{[
							{ icon: <WhatsAppIcon />, link: 'https://api.whatsapp.com/send?phone=919827078928' },
							{ icon: <FacebookIcon />, link: 'https://www.facebook.com/profile.php?id=100088026692168' },
							{ icon: <InstagramIcon />, link: 'https://www.instagram.com/shriharitenthouse/' },
							{ icon: <YouTubeIcon />, link: 'https://www.youtube.com/' },
							{ icon: <WhatsAppIcon />, link: 'https://api.whatsapp.com/send?phone=919300661900' },
						].map((social, index) => (
							<motion.a
								key={index}
								href={social.link}
								target='_blank'
								rel="noopener noreferrer"
								whileHover={{ scale: 1.2, color: theme.palette.primary.main }}
								style={{ color: isDark ? '#fff' : '#333', margin: '1rem' }}
							>
								{social.icon}
							</motion.a>
						))}
					</div>
					<h3 className={style.callText}>Call us any time</h3>
				</div>

				<div className={style.mapSection}>
					<iframe
						title="Location Map"
						src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1228.7796178479978!2d76.7302392!3d23.0239513!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397cc4a6524ed9e5%3A0x25e9b0ad290ab416!2zMjPCsDAxJzI1LjYiTiA3NsKwNDMnNDkuOSJF!5e1!3m2!1sen!2sin!4v1671201994951!5m2!1sen!2sin'
						width='100%'
						height='450'
						style={{ border: 0, borderRadius: '2rem' }}
						allowFullScreen=''
						loading='lazy'
						referrerPolicy='no-referrer-when-downgrade'
					></iframe>
				</div>
			</div>

			<MyFooter />
		</motion.div>
	);
};

export default Contact;
